import { render, staticRenderFns } from "./DocumentInsertionCampaign.vue?vue&type=template&id=5e287f44&"
import script from "./DocumentInsertionCampaign.vue?vue&type=script&lang=ts&"
export * from "./DocumentInsertionCampaign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports